import parse, { domToReact } from 'html-react-parser';

export default function HtmlToJsx({ html, className = null }) {
  if (typeof html !== 'string') {
    return html;
  }

  const options = {
    replace: (node) => {
      if (node.name === 'a' && node.attribs && node.attribs.href) {
        if (node.attribs.href.startsWith('http')) {
          node.attribs.target = '_blank';
          node.attribs.rel = 'external noopener noreferrer';
          return <a {...node.attribs}>{domToReact(node.children, options)}</a>;
        }
      }
    }
  };

  const parsedHtml = html ? parse(html, options) : null;
  if (className) {
    return <div className={className}>{parsedHtml}</div>;
  }
  return <>{parsedHtml}</>;
}
